import { createContext, useContext, useEffect, useMemo, useState } from "react";

//TODO: I don't know how this all works if two subscribers have the same priority
//TODO: the hooks in the GlobalEventProvider could come from the same common hook
type EventSubscriber = {
  priority: number;
  id: string;
};

type KeyEventSubscriberCallback = (event: KeyboardEvent) => void;
export type KeyEventSubscriber = EventSubscriber & {
  useCallbackGeneratedCB: KeyEventSubscriberCallback;
};

interface KeyEventApiContextType {
  addKeyPressSubscriber: (receiver: KeyEventSubscriber) => void;
  removeKeyPressSubscriber: (receiver: KeyEventSubscriber) => void;
}
const KeyEventApiContext = createContext<KeyEventApiContextType>(null!);
export const useKeyEventApiContext = () => useContext(KeyEventApiContext);

function addSubscriberIfNotPresent<T extends EventSubscriber>(
  subscriber: T,
  list: T[]
): T[] {
  return list.find((s) => s.id === subscriber.id)
    ? list
    : [...list, subscriber];
}

function removeSubscriberIfPresent<T extends EventSubscriber>(
  subscriber: T,
  list: T[]
): T[] {
  return list.find((s) => s.id === subscriber.id)
    ? list.filter((s) => s.id !== subscriber.id)
    : list;
}

function getHighestPrioritySubscribers<T extends EventSubscriber>(
  subscribers: T[]
): T[] {
  if (subscribers.length === 0) {
    return [];
  }

  // First, find the highest priority value
  const highestPriority = subscribers.reduce(
    (max, subscriber) => Math.max(max, subscriber.priority),
    subscribers[0].priority
  );
  //console.log("now filtering, so out of", subscribers);
  //console.log("highest priority value be", highestPriority);

  // Now, filter subscribers to get all with the highest priority
  const rv = subscribers.filter(
    (subscriber) => subscriber.priority === highestPriority
  );
  //console.log("these be", rv);
  return rv;
}

interface ProviderProps {
  children: React.ReactNode | React.ReactNode[];
}

export const GlobalKeyEventProvider: React.FC<ProviderProps> = ({
  children,
}) => {
  //use refs as opposed to state/reducer so as to not trigger re-renders
  //of this component and therefore all of it's context subscribers
  //const keyPressSubscribers = useRef([] as KeyEventSubscriber[]);
  const [keyPressSubscribers, setKeyPressSubscribers] = useState<
    KeyEventSubscriber[]
  >([]);

  const addSubscriber = (subscriber: KeyEventSubscriber) => {
    //if (subscriber.id === "fuzzy-search") {
    //console.log("before adding", keyPressSubscribers.current);
    //console.log("before adding", keyPressSubscribers);
    //}
    //keyPressSubscribers.current = addSubscriberIfNotPresent(
    //subscriber,
    //keyPressSubscribers.current
    //);
    //console.log("adding subscriber to state", subscriber.id);
    setKeyPressSubscribers((prev) =>
      addSubscriberIfNotPresent(subscriber, prev)
    );
    //if (subscriber.id === "fuzzy-search") {
    //console.log("after adding", keyPressSubscribers);
    //console.log("after adding", keyPressSubscribers.current);
    //}
  };

  const removeSubscriber = (subscriber: KeyEventSubscriber) => {
    setKeyPressSubscribers((prev) =>
      removeSubscriberIfPresent(subscriber, prev)
    );
    //keyPressSubscribers.current = removeSubscriberIfPresent(
    //subscriber,
    //keyPressSubscribers.current
    //);
  };

  //useEffect(() => {
  //let lastSubscribers: KeyEventSubscriber[] | null = null;
  //const intervalId = setInterval(() => {
  //if (keyPressSubscribers.current !== lastSubscribers) {
  //lastSubscribers = keyPressSubscribers.current;
  //console.log("subscribers have changed:", lastSubscribers);
  //}
  //}, 250);
  //return () => clearInterval(intervalId);
  //}, []);

  const prioritySubscribers = useMemo(
    () => getHighestPrioritySubscribers(keyPressSubscribers),
    [keyPressSubscribers]
  );

  //useEffect(() => {
  //console.log("prioritySubscribers changed to:", prioritySubscribers);
  //}, [prioritySubscribers]);

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      prioritySubscribers.forEach((s) => {
        //console.log("sending event to ", s.id);
        s.useCallbackGeneratedCB(event);
      });
    };
    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, [prioritySubscribers]);

  //useEffect(() => {
  //console.log(
  //"all subscribers just changed, currently:",
  //keyPressSubscribers
  //);
  //console.log("all subscribers be", keyPressSubscribers);
  //const subscribers = getHighestPrioritySubscriber(keyPressSubscribers);
  //console.log("chosen subscribers be", subscribers);
  //const handleKeyPress = (event: KeyboardEvent) => {
  //if (subscribers.length > 0) {
  //subscribers.forEach((s) => s.useCallbackGeneratedCB(event));
  //}
  //};
  ////TODO: THIS IS VERY MISLEADING
  //window.addEventListener("keydown", handleKeyPress);
  //return () => window.removeEventListener("keydown", handleKeyPress);
  //}, [keyPressSubscribers]);

  return (
    <KeyEventApiContext.Provider
      value={{
        addKeyPressSubscriber: addSubscriber,
        removeKeyPressSubscriber: removeSubscriber,
      }}
    >
      {children}
    </KeyEventApiContext.Provider>
  );
};
